/* src/app/modules/portal/components/lastDataSourceRefresh/srsRefreshButton/srsRefreshButton.component.scss */
.spinner {
  position: absolute;
  left: 0.75rem;
  top: 0.2rem;
  margin: initial;
  --sh-spinner-width-s: 1.5rem;
  --sh-spinner-height-s: 1.5rem;
  --sh-spinner-border-width: 0.2rem;
}
:host {
  display: flex;
  flex-direction: row;
  align-items: center;
}
:host sh-text {
  padding-left: 1rem;
}
.button {
  position: relative;
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.error {
  display: block;
  color: rgba(var(--functional-red), var(--opacity-1));
}
[screen-phone] :host-context {
  display: flex;
  flex-direction: column;
  align-items: left;
}
[screen-phone] :host-context .button {
  margin-right: auto;
}
[screen-phone] :host-context sh-text {
  padding-top: 0rem;
}
/*# sourceMappingURL=srsRefreshButton.component.css.map */
